// extracted by mini-css-extract-plugin
module.exports = {"container":"EditCard_container__2Rw0Y","title":"EditCard_title__3L2pX"};